import type { MapEmbedComponent } from "../../types";

/** Seul préfixe d'iframe autorisé : l'embed officiel Google Maps. Tout autre URL
 *  est ignorée — un site de banque centrale n'affiche jamais une iframe arbitraire
 *  collée par erreur dans l'admin (et la CSP frame-src la bloquerait de toute façon). */
const ALLOWED_EMBED_PREFIX = "https://www.google.com/maps/embed";

/** Google Maps embed renderer — carte pleine largeur, chargée en lazy. */
export function MapEmbedRenderer({ component }: { component: MapEmbedComponent }) {
  const { embedUrl, title, height } = component.content;

  const url = (embedUrl ?? "").trim();
  if (!url.startsWith(ALLOWED_EMBED_PREFIX)) return null;

  const h = typeof height === "number" && height >= 200 && height <= 800 ? height : 420;

  return (
    <section className="mt-6 md:mt-8">
      <div className="overflow-hidden rounded-xl border border-[#005CA9]/15 shadow-sm">
        <iframe
          src={url}
          title={title?.trim() || "Carte"}
          className="block w-full"
          style={{ height: `${h}px`, border: 0 }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </section>
  );
}
